<div class="flex flex-col h-full">
  <!-- Header Section -->
  <div class="flex items-center justify-between">
    <div class="flex items-center gap-2">
      <img src="/icons/building.svg" alt="building" class="text-4xl" />
      <h1 class="text-2xl font-bold text-primary">Organization Management</h1>
    </div>
    <div>
      <button
        class="btn bg-transparent border-base-300 btn-sm rounded-none text-primary hover:bg-primary hover:text-white group"
        (click)="addOrganizationModal()"
      >
        <fa-icon [icon]="'plus'" class="text-icon-inactive group-hover:text-white"></fa-icon>
        Add New Organization
      </button>
    </div>
  </div>
  <div class="text-sm py-3">Total Items: {{ totalOrganizationsCount() }}</div>
  <div class="flex justify-between items-center mb-4">
    <div class="flex items-center space-x-2">
      <select
        class="select select-bordered select-sm w-fit rounded-sm focus:outline-none focus:ring-0"
        [ngModel]="activeFilter()"
        (ngModelChange)="onActiveFilterChange($event)"
      >
        <option value="active">Active</option>
        <option value="deleted">Deleted</option>
      </select>
    </div>
  </div>

  <!-- Organization List Table -->
  <div class="flex flex-1 overflow-hidden">
    <div class="flex-1 flex flex-col overflow-hidden">
      <app-organization-list
        class="w-full h-full"
        [activeFilter]="activeFilter()"
        (organizationSelected)="onOrganizationSelected($event)"
        (configureGuidelines)="onConfigureGuidelines($event)"
      ></app-organization-list>
    </div>
  </div>
</div>
<app-add-organization-modal></app-add-organization-modal>
<app-delete-organization-confirmation-modal
  [organizationName]="selectedOrganization?.display_name || ''"
  (confirmed)="onDeleteConfirmed()"
></app-delete-organization-confirmation-modal>
<app-delete-organization-warning-modal
  [organizationName]="selectedOrganization?.display_name || ''"
></app-delete-organization-warning-modal>
<app-configure-guidelines-modal></app-configure-guidelines-modal>
